export const demoDatasetAssetPath = '/demo/finansee-demo-customers.xlsx';

// The file the demo actually hands out. The full extract above has 1,121
// clients, which is past the 150 a Solo plan allows and past the 1,000
// included in Team: an adviser who downloaded it to try the product hit a
// limit on their first import instead of seeing a result. This one is the
// same 28 columns and the same country mix, cut to fit the entry plan.
export const demoTrialSampleAssetPath = '/demo/finansee-muestra-solo.xlsx';
export const demoTrialSampleCount = 120;
export const demoTrialSampleFileName = demoTrialSampleAssetPath.split('/').pop();

/**
 * The full synthetic book used by the illustrative workspace. Import and
 * download actions offer the smaller trial sample above instead.
 *
 * Until 21 October 2026 its main countries were USA, AUS, DEU, GBR and CAN
 * and its amounts carried no currency, which read as someone else's book to
 * the customer the catalogue is priced for: a Spanish independent adviser.
 * The file and these figures now describe a Spanish-plausible book in euro.
 *
 * Nothing here is a result. The fields are what an extract contains — age,
 * declared risk profile, knowledge score, allocation — never performance.
 */
export const demoDatasetSummary = {
    label: 'Synthetic demo extract',
    customersLabel: '1.1k client profiles',
    customersCount: 1121,
    columnsCount: 28,
    avgRiskProfile: '5.4 / 10',
    avgKnowledgeScore: '48 / 100',
    avgAge: '52 years',
    currency: 'EUR',
    topCountries: ['ESP', 'PRT', 'FRA', 'DEU', 'MEX'],
};

/**
 * Five clients worth opening in the extract. Each angle is a review prompt —
 * something to verify — not a prediction about the client and not a claim
 * about an outcome.
 */
export const demoSpotlightCustomers = [
    {
        customerId: 'CUST3490',
        title: 'Conservative declared risk, concentrated portfolio',
        angle: 'Shows what the review list leads with: a mismatch between what the client declared and what the portfolio holds.',
        country: 'ESP',
        age: 61,
        metrics: ['Risk 3/10', 'Single stock 42%', 'Home market 88%'],
    },
    {
        customerId: 'CUST3089',
        title: 'High declared risk with a low knowledge score',
        angle: 'Useful for seeing how two declared fields are shown side by side instead of folded into one number.',
        country: 'ESP',
        age: 46,
        metrics: ['Risk 9/10', 'Knowledge 21/100', 'Leverage 1.8x'],
    },
    {
        customerId: 'CUST3511',
        title: 'Drift against the model, no source date',
        angle: 'The case that shows missing data staying missing: the client is listed and the absent date is the first thing to verify.',
        country: 'ESP',
        age: 72,
        metrics: ['Drift 14 points', 'No source date', 'Coverage 52%'],
    },
    {
        customerId: 'CUST2973',
        title: 'Cash position with no mandate on file',
        angle: 'Shows a signal the platform will not score: without a reference model there is nothing to compare the cash to.',
        country: 'PRT',
        age: 55,
        metrics: ['Cash 38%', 'No mandate', 'Coverage 74%'],
    },
    {
        customerId: 'CUST2853',
        title: 'Extract months old',
        angle: 'Shows how stale evidence is labelled rather than silently treated as current.',
        country: 'FRA',
        age: 64,
        metrics: ['Observed 30 Jun 2026', 'Coverage 61%', 'Drift 17 points'],
    },
];
